module.exports = __webpack_public_path__ + "media/images/pic/teachers/krzysztof-walaszek-00257d7bc368b7710dfd262a97773832.png";